
import axios from "axios"


const state = {
    ProjectList: []
};


const getters = {
    GetProjectList(state:any) {
        return state.ProjectList;
    }
};

const mutations = {

    SetProjectList(state:any, list:any) {
        state.ProjectList = list;
    }

};

const actions = {
    GetProjectListFromServer(context:any, filter:any) {
        axios.get("Task/GetProjectList", {
            params: {
                text: filter.text,
                personId: filter.personId,
                projectId: filter.projectId,
            }
        })
           .then(data => {
                context.commit("SetProjectList", data.data);
            });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
